import { SearchEntity } from '@finance-lab/utils/types'
import ApiBase from './Api'

const SEARCH_API_PATHS = {
    SEARCH: '/search',
}

class SearchApi extends ApiBase {
    async freeSearch(query: string): Promise<SearchEntity[]> {
        const response = await this._getRequest(SEARCH_API_PATHS.SEARCH, {
            queryParameters: { q: query },
        })

        return response as SearchEntity[]
    }
}

export default SearchApi
